import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Search, ChevronLeft, ChevronRight } from 'lucide-react';

export const UsersSection = ({
  users,
  usersMeta,
  searchQuery,
  setSearchQuery,
  currentPage,
  setCurrentPage,
  onPageChange,
}) => (
  <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="users-table-section">
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-5">
      <h3 className="text-lg font-semibold text-stone-900">Registered Users ({usersMeta.total})</h3>
      <div className="relative w-full sm:w-72">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
        <Input
          placeholder="Search by email or name..."
          value={searchQuery}
          onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
          className="pl-9 rounded-full border-stone-200"
          data-testid="user-search-input"
        />
      </div>
    </div>

    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="users-table">
        <thead>
          <tr className="border-b border-stone-200">
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Email</th>
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Name</th>
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Role</th>
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Trips</th>
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Nationality</th>
            <th className="text-left py-3 px-3 text-xs font-bold uppercase tracking-wider text-stone-500">Joined</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} className="border-b border-stone-100 hover:bg-[#FDFDF9] transition-colors">
              <td className="py-3 px-3 text-stone-800 font-medium">{u.email}</td>
              <td className="py-3 px-3 text-stone-600">{u.first_name} {u.last_name}</td>
              <td className="py-3 px-3">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${u.role === 'admin' ? 'bg-amber-100 text-amber-800' : 'bg-stone-100 text-stone-600'}`}>
                  {u.role}
                </span>
              </td>
              <td className="py-3 px-3 text-stone-600 font-medium">{u.trip_count}</td>
              <td className="py-3 px-3 text-stone-500">{u.nationality || '-'}</td>
              <td className="py-3 px-3 text-stone-400">{u.created_at?.slice(0, 10)}</td>
            </tr>
          ))}
          {users.length === 0 && (
            <tr>
              <td colSpan={6} className="py-8 text-center text-stone-400">No users found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {usersMeta.pages > 1 && (
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-stone-100">
        <p className="text-xs text-stone-500">
          Page {usersMeta.page} of {usersMeta.pages} ({usersMeta.total} users)
        </p>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1} className="rounded-full h-8 w-8 p-0" data-testid="users-prev-page">
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <Button variant="outline" size="sm" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= usersMeta.pages} className="rounded-full h-8 w-8 p-0" data-testid="users-next-page">
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    )}
  </div>
);
